import styled, { css } from "styled-components";

export const Padding = styled.div`
  ${(props) =>
    props.padding &&
    css`
      padding: ${(props) => props.padding.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      padding-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      padding-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.bottom &&
    css`
      padding-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      padding-right: ${(props) => props.right}px;
    `};
`;

export const Margin = styled.div`
  ${(props) =>
    props.margin &&
    css`
      margin: ${(props) => props.margin.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      margin-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      margin-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.bottom &&
    css`
      margin-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      margin-right: ${(props) => props.right}px;
    `};
`;

export const LabelStyled = styled.label`
  ${(props) =>
    props["font-size"] &&
    css`
      font-size: ${(props) => props["font-size"]}px;
    `};
  ${(props) =>
    props.color &&
    css`
      color: ${(props) => props.color};
    `};
`;
